import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["defaultCloudId"];
import React from 'react';
import { useFormState } from 'react-final-form';
import { UserPicker } from '@atlaskit/link-create';
export var UserPickerForSelectedSite = function UserPickerForSelectedSite(_ref) {
  var _formProps$values;
  var defaultCloudId = _ref.defaultCloudId,
    props = _objectWithoutProperties(_ref, _excluded);
  var formProps = useFormState();
  var siteIdFromFormOrDefault = (formProps === null || formProps === void 0 || (_formProps$values = formProps.values) === null || _formProps$values === void 0 || (_formProps$values = _formProps$values.site) === null || _formProps$values === void 0 ? void 0 : _formProps$values.value.cloudId) || defaultCloudId;
  return /*#__PURE__*/React.createElement(UserPicker, _extends({}, props, {
    siteId: siteIdFromFormOrDefault
  }));
};